import { Column, Row } from '~components/table-view';
import WorkerQualifications from '~weekly-planner/components/common/WorkerQualifications';
import WorkerFocusAction from '~weekly-planner/components/WorkerFocusAction';

import AppointmentInfo from './AppointmentInfo';

// Define columns for TableView for missing qualifications
const getMissingQualificationsColumns = (extendedView: boolean): Column[] => [
  {
    id: 'appointment',
    header: 'Appointment',
    type: 'custom',
    component: AppointmentInfo,
    componentProps: (row: Row) => ({
      date: row.date,
      start_time: row.start_time,
      client: row.client,
    }),
  },
  {
    id: 'worker',
    header: 'Worker',
    type: 'text',
    deriveValue: (row) => row.user?.full_name,
  },
  {
    id: 'missing_qualifications',
    header: 'Missing Qualifications',
    type: 'custom',
    component: WorkerQualifications,
    componentProps: (row: Row) => ({
      qualifications: (row.qualification_level ?? []).filter(
        (item: string) => !row.user?.qualifications?.includes(item),
      ),
      isCondensed: !extendedView,
      isWrapped: !extendedView,
    }),
  },
  {
    id: 'actions',
    header: '',
    type: 'custom',
    component: WorkerFocusAction,
    componentProps: (row: Row) => ({ userId: row.user?.id }),
  },
];

export default getMissingQualificationsColumns;
